module.exports = __webpack_public_path__ + "static/media/walking.03c119d3.svg";